module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.ad3ac7b0.jpg";